import { HomeBody } from './HomeBody';
import { HomeHeaderSection } from './HomeHeaderSection';

export const Home = () => {
  return (
    <>
      <HomeHeaderSection />
      <HomeBody />
    </>
  );
};
